<template>
	<div :class="sideOverShow ? 'side-over--active' : ''">
		<div
			class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
			v-if="sideOverShow"
			@click="sideOverShow = false"
		></div>
		<Student @close="sideOverShow = false" />
	</div>
	<div class="pb-30 px-10 md-down:px-4">
		<div
			class="__report-lesson__header pt-10 flex flex-nowrap justify-between items-center"
		>
			<div
				class="__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer"
			>
				<svg
					class="mr-2"
					fill="none"
					height="28"
					viewBox="0 0 28 28"
					width="28"
					xmlns="http://www.w3.org/2000/svg"
					@click="$router.back()"
				>
					<path
						d="M17.5 7L10.5 14L17.5 21"
						stroke="#94A3B8"
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
					/>
				</svg>
				<div>
					<div>
						{{
							noticeId
								? 'Chỉnh sửa thông báo học phí'
								: 'Tạo thông báo học phí'
						}}
					</div>
				</div>
			</div>
			<div class="flex items-center justify-end gap-8">
				<button
					class="button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600"
					type="button"
					@click="exit"
				>
					<svg
						class="mr-2 text-neutral-400"
						fill="none"
						height="16"
						viewBox="0 0 16 16"
						width="16"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
							fill="currentColor"
						/>
						<path
							d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
							fill="currentColor"
						/>
					</svg>
					Thoát
				</button>
			</div>
		</div>
		<div class="flex items-center justify-end pb-10 gap-4 mt-4">
			<button
				class="button-p md-down:w-full w-fit md:px-10 btn--ghost flex items-center gap-2"
				type="button"
				@click="fetchData(true)"
			>
				<div>Cập nhật dữ liệu</div>
				<Popper :arrow="true" hover placement="bottom">
					<div class="cursor-pointer">
						<img
							src="@/assets/images/icons/info-circle-line-yellow.png"
							alt=""
							width="16"
							height="16"
						/>
					</div>
					<template #content>
						<div class="max-w-lg text-neutral-600">
							Nếu biểu mẫu học phí đã được thay đổi, nhấn <br />
							<span class="font-semibold"
								>‘Cập nhật dữ liệu’</span
							>
							để tải lại nội dung mới nhất.
						</div>
					</template>
				</Popper>
			</button>
			<button
				class="button-p text-center md-down:w-full w-fit md:px-10 btn--ghost"
				type="button"
				@click="sideOverShow = true"
			>
				Thống kê chuyên cần
			</button>
		</div>
		<div v-if="isLoading" class="mt-20">
			<Loading />
		</div>
		<div v-else>
			<div class="relative my-6">
				<div
					aria-hidden="true"
					class="absolute inset-0 flex md:items-center"
				>
					<div class="w-full border-t border-neutral-300" />
				</div>
				<div class="relative flex justify-center">
					<div
						class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
					>
						Thông tin
					</div>
				</div>
			</div>
			<div class="mt-10 max-w-3xl mx-auto">
				<div class="flex items-center justify-between">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
					>
						Tiêu đề
					</div>
					<div class="w-1/2">{{ data?.title }}</div>
				</div>
				<div class="mt-8 flex items-center justify-between">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
					>
						Tên học sinh
					</div>
					<div class="w-1/2">{{ data?.student?.name }}</div>
				</div>
				<div class="mt-8 flex items-center justify-between">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
					>
						Lớp bán trú
					</div>
					<div class="w-1/2">
						{{ data?.day_care_class?.name }}
					</div>
				</div>
				<div class="mt-8 flex justify-between">
					<div
						class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
					>
						Lớp nhóm
					</div>
					<div class="w-1/2">
						<div
							v-for="gClass in data?.group_classes"
							:key="gClass.id"
						>
							{{ gClass.name }}
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10 max-w-3xl mx-auto">
				<div v-for="(form, index) in forms" :key="index">
					<div v-if="form.cards.length > 0">
						<div class="relative my-6">
							<div
								aria-hidden="true"
								class="absolute inset-0 flex md:items-center"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div class="relative flex justify-center">
								<div
									class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
								>
									{{ form.title }}
								</div>
							</div>
						</div>
						<div v-for="card in form.cards" :key="card.label">
							<div class="bg-white rounded-xl border mb-6">
								<div class="px-8 pt-6 w-full">
									<div
										class="font-semibold text-neutral-500 text-lg"
									>
										{{ card.name }}
									</div>
									<div
										v-if="
											card.label ===
												'additional_charges' ||
											card.label === 'additional_refund'
										"
										class="text-neutral-400 text-sm"
									>
										Để trống nếu học sinh không có khoản
										{{
											card.label === 'additional_charges'
												? 'thu'
												: 'hoàn phí'
										}}
										bổ sung
									</div>
								</div>
								<div class="p-8 flex flex-col gap-6">
									<div
										class="flex w-full gap-4 items-center"
										v-if="
											card.label ===
												'additional_charges' ||
											card.label === 'additional_refund'
										"
									>
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											{{
												card.label ===
												'additional_charges'
													? 'Tên khoản thu bổ sung'
													: 'Tên khoản hoàn phí bổ sung'
											}}
										</div>
										<div class="w-1/2 input-group">
											<input
												:placeholder="
													card.label ===
													'additional_charges'
														? 'Nhập tên khoản thu bổ sung'
														: 'Nhập tên khoản hoàn phí bổ sung'
												"
												v-model="card.custom_name"
												type="text"
											/>
										</div>
									</div>
									<div class="flex w-full gap-4 items-center">
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											Chi phí
										</div>
										<div
											class="w-1/2 input-group"
											v-if="
												card.label ===
												'additional_charges' ||
												card.label ===
												'additional_refund'
											"
										>
											<input
												:value="priceDisplayValue(card.price)"
												class="bg-white"
												placeholder="Nhập chi phí"
												@input="(e) => handlePriceInput(e, card)"
											/>
										</div>
										
										<div class="w-1/2 input-group" v-else>
											{{
												$filters.priceFormat(card.price)
											}}
										</div>
									</div>
									<div
										class="flex w-full gap-4 items-center"
										v-if="
											card.label !==
												'additional_charges' &&
											card.label !== 'additional_refund'
										"
									>
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											Số lượng
										</div>
										<div class="w-1/2 input-group">
											<input
												placeholder="Số lượng"
												v-model="card.count"
												type="number"
											/>
										</div>
									</div>
									<div
										class="flex w-full gap-4 items-center"
										v-if="
											card.label !==
												'additional_charges' &&
											card.label !== 'additional_refund'
										"
									>
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											Thành tiền
										</div>
										<div class="w-1/2 input-group">
											{{
												$filters.priceFormat(
													card.count * card.price
												)
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="mt-10 max-w-3xl mx-auto">
				<div>
					<div>
						<div class="relative my-6">
							<div
								aria-hidden="true"
								class="absolute inset-0 flex md:items-center"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div class="relative flex justify-center">
								<div
									class="px-2.5 py-1 bg-body text-neutral-600 font-semibold pb-1 text-2xl"
								>
									Ghi chú và thông tin chuyển khoản
								</div>
							</div>
						</div>
						<div>
							<div class="bg-white rounded-xl border mb-6">
								<div class="p-8 flex flex-col gap-6">
									<div class="flex w-full gap-4">
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											Ghi chú riêng cho từng học sinh
										</div>
										<div class="w-1/2 input-group">
											<textarea
												v-model="note"
												rows="8"
												placeholder="Nhập ghi chú riêng cho từng học sinh"
											></textarea>
										</div>
									</div>
									<div
										class="flex w-full gap-4"
										v-if="
											data?.tuition_template
												?.enabled_common_note
										"
									>
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											Ghi chú chung
										</div>
										<div
											v-if="
												data?.data
													?.other_components_and_settings
													?.tuition_common_note
													?.content
											"
											class="w-1/2 input-group"
											v-html="
												data?.data?.other_components_and_settings?.tuition_common_note?.content.replace(
													/\n/g,
													'<br />'
												)
											"
										></div>
									</div>
									<div
										class="flex w-full gap-4"
										v-if="
											data?.tuition_template
												?.enabled_qr_code
										"
									>
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											Mã QR
										</div>
										<div class="w-1/2">
											<img
												style="
													width: 100px;
													height: 100px;
												"
												:src="
													data?.data
														?.other_components_and_settings
														?.tuition_common_note
														?.asset_url
												"
												alt=""
											/>
										</div>
									</div>
								</div>
							</div>
							<div
								class="bg-white rounded-xl border mb-6"
								v-if="statistics.length > 0"
							>
								<div
									class="p-8 py-5 text-lg flex items-center justify-between w-full border-b"
								>
									<div class="font-semibold text-neutral-500">
										Thống kê chuyên cần
									</div>
								</div>
								<div class="p-8 flex flex-col gap-6">
									<div
										class="flex w-full gap-4 items-center"
										v-for="i in statistics"
										:key="i"
									>
										<div
											class="uppercase text-neutral-400 text-sm font-medium tracking-wide w-1/2"
										>
											{{ i.name }}
										</div>
										<div class="w-1/2 input-group">
											<input
												placeholder="Nhập số buổi"
												type="number"
												v-model="i.count"
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				class="mt-10 max-w-3xl mx-auto flex items-center justify-center md:justify-end md:gap-6"
			>
				<button
					class="button-p text-center md-down:w-full w-fit md:px-10 btn--ghost"
					type="button"
					@click="saveNotice"
				>
					Lưu bản nháp
				</button>
				<button
					class="button-p text-center md-down:w-full w-fit md:px-10"
					type="button"
					@click="preview"
				>
					Xem trước thông báo
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { ACTIONS } from '@/enums/Common';
import { $api } from '@/services';
import { _ROUTER_NAME } from '@/enums';
import Loading from '@/components/common/Loading';
import Student from './Student.vue';
import Popper from 'vue3-popper';
export default {
	name: 'FeeNoticesCreate',
	components: { Loading, Student, Popper },
	data() {
		return {
			modalIsOpen: false,
			idCreate: '',
			modalType: '',
			inProgress: false,
			forms: [],
			totalFee: 0,
			totalRefund: 0,
			formFeeLabel: [],
			formRefundLabel: [],
			isLoading: false,
			sideOverShow: false,
			note: '',
			statistics: [],
		};
	},

	computed: {
		_ROUTER_NAME() {
			return _ROUTER_NAME;
		},

		id() {
			return this.$route.params.id;
		},
		studentId() {
			return this.$route.query.id;
		},
		monthStart() {
			return this.$route.query.month_start;
		},
		tuitionId() {
			return this.$route.query.tuitionId;
		},
		noticeId() {
			return this.$route.query.noticeId;
		},
		currentOrg() {
			return this.$store.state.profile.current_org;
		},

		profile() {
			return this.$store.state.profile;
		},

		type() {
			return ACTIONS;
		},
	},

	created() {
		this.fetchData();
	},

	methods: {
		async fetchData(force = false) {
			this.isLoading = true;
			try {
				const {
					data: { data },
				} = await $api.org.getStudentTuitionFee(Number(this.id), {
					student_id: this.studentId,
					month_start: this.monthStart,
					force: force,
				});
				this.data = data;
				if (this.data.data?.schedule_statistics) {
					this.statistics = this.data.data?.schedule_statistics;
				}
				this.forms.push({
					title: 'Khoản thu',
					cards: this.data?.data?.fee?.default.map((i) => i),
				});

				this.forms.push({
					title: 'Các khoản thu khác',
					cards: this.data?.data?.fee?.other.map((i) => i),
				});

				this.forms.push({
					title: 'Hoàn phí',
					cards: this.data?.data?.refund?.default.map((i) => i),
				});

				this.forms.push({
					title: 'Các khoản hoàn phí khác',
					cards: this.data?.data?.refund?.other.map((i) => i),
				});
				if (this.noticeId) this.fetchNotification();
			} catch (error) {
				console.log(error);
			} finally {
				this.isLoading = false;
			}
		},
		async fetchNotification() {
			try {
				const res = await $api.notification.getFeeNotification(
					this.noticeId
				);
				this.note =
					res?.data?.data?.notice?.student_tuition_from_template?.note;
				this.statistics =
					res?.data?.data?.notice?.student_tuition_from_template?.data?.schedule_statistics;
			} catch (err) {
				console.log(err);
			}
		},
		getTotal(arr) {
			let sum = 0;
			for (let card of arr) sum = sum + card.count * card.price;
			return sum;
		},
		calData() {
			this.forms.forEach((form, index) =>
				this.forms[index].cards.forEach(
					(i) => (i.total = i.count * i.price)
				)
			);
			this.totalFee = this.getTotal(
				this.forms[0].cards.concat(this.forms[1].cards)
			);
			this.totalRefund = this.getTotal(
				this.forms[2].cards.concat(this.forms[3].cards)
			);
		},
		async saveNotice() {
			this.inProgress = true;
			try {
				this.calData();
				if (this.tuitionId) {
					await $api.notification.editFeeNotification(
						this.id,
						this.tuitionId,
						{
							note: this.data.note,
							data: {
								other_components_and_settings:
									this.data?.data
										?.other_components_and_settings,
								fee: {
									default: this.forms[0].cards,
									other: this.forms[1].cards,
									total: this.totalFee,
								},
								refund: {
									default: this.forms[2].cards,
									other: this.forms[3].cards,
									total: this.totalRefund,
								},
								schedule_statistics: this.statistics,
								total: this.totalFee - this.totalRefund,
							},
						}
					);
				} else {
					await $api.notification.sendFeeNotification({
						send: false,
						student_id: this.studentId,
						subject: 'all_parents_of_a_student',
						title: this.data.title_of_notice,
						month_start: this.monthStart,
						content: this.data.content_of_notice,
						student_tuition_from_template: {
							note: this.note,
							data: {
								other_components_and_settings:
									this.data?.data
										?.other_components_and_settings,
								fee: {
									default: this.forms[0].cards,
									other: this.forms[1].cards,
									total: this.totalFee,
								},
								refund: {
									default: this.forms[2].cards,
									other: this.forms[3].cards,
									total: this.totalRefund,
								},
								schedule_statistics: this.statistics,
								total: this.totalFee - this.totalRefund,
							},
							title: this.data.title,
							tuition_template_id: this.data.tuition_template.id,
						},
					});
				}
				this.$store.dispatch('setAlertMessage', {
					message: 'Lưu bản nháp thành công',
				});
				this.$router.push('/fee-notices');
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.inProgress = false;
			}
		},
		async preview() {
			this.calData();
			await $api.notification.sendFeeNotification({
				send: false,
				student_id: this.studentId,
				subject: 'all_parents_of_a_student',
				title: this.data.title_of_notice,
				month_start: this.monthStart,
				content: this.data.content_of_notice,
				student_tuition_from_template: {
					note: this.note,
					data: {
						other_components_and_settings:
							this.data?.data?.other_components_and_settings,
						fee: {
							default: this.forms[0].cards,
							other: this.forms[1].cards,
							total: this.totalFee,
						},
						refund: {
							default: this.forms[2].cards,
							other: this.forms[3].cards,
							total: this.totalRefund,
						},
						schedule_statistics: this.statistics,
						total: this.totalFee - this.totalRefund,
					},
					title: this.data.title,
					tuition_template_id: this.data.tuition_template.id,
				},
			});
			let newForm = [
				this.forms[0].cards.concat(this.forms[1].cards),
				this.forms[2].cards.concat(this.forms[3].cards),
			];
			window.sessionStorage.setItem(
				'formPreview',
				JSON.stringify({
					name: this.data?.student?.name,
					day_care_class: this.data?.day_care_class,
					group_classes: this.data?.group_classes,
					title: this.data?.title,
					title_of_notice: this.data?.title_of_notice,
					forms: newForm,
					tuition_id: this.data?.tuition_template.id,
					month_start: this.monthStart,
					content: this.data.content_of_notice,
					totalFee: this.totalFee,
					totalRefund: this.totalRefund,
					note: this.note,
					statistics: this.statistics,
					common_note:
						this.data?.data?.other_components_and_settings
							?.tuition_common_note?.content,
					asset_url:
						this.data?.data?.other_components_and_settings
							?.tuition_common_note?.asset_url,
					show_discount:
						this.data?.tuition_template
							?.enabled_show_original_price,
					other_components_and_settings:
						this.data?.data?.other_components_and_settings,
				})
			);
			this.$router.push({
				name: _ROUTER_NAME.FEE_NOTICES_PREVIEW,
				params: {
					id: this.studentId,
				},
				query: {
					templateId: this.id,
					tuitionId: this.tuitionId,
					monthStart: this.monthStart,
				},
			});
		},

		openExitConfirm() {
			this.modalType = this.type.DELETE;
			this.modalIsOpen = true;
		},

		exit() {
			this.modalIsOpen = false;
			this.$router.push({
				name: _ROUTER_NAME.TUITION_FORMS,
			});
		},

		onlyNumbers(text) {
			return Number(text.replace(/\./g, ''));
		},

		priceDisplayValue(price) {
			const num = Number(price);
			if (!num && num !== 0) return '';
			return this.$filters.priceFormat(num);
		},
		handlePriceInput(event, card) {
			const digits = String(event.target.value).replace(/\D/g, '');
			card.price = digits === '' ? 0 : Number(digits);
		},
	},
};
</script>

<style lang="scss" scoped>
.title {
	font-weight: 600;
	box-shadow: none !important;

	&::placeholder {
		font-weight: normal;
	}
}
</style>
